import React from "react";
import './LoadingDataComponent.scss';
import { useTranslation } from "react-i18next";

const LoadingDataComponent = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <div className="loading-data-component">
            <div className="ldc-bar-track">
                <div className="ldc-bar" />
            </div>
            <div className="ldc-body">
                <div className="ldc-dots">
                    <span /><span /><span />
                </div>
                <p className="ldc-label">{t('components.loading-data.loading-please-wait')}</p>
            </div>
        </div>
    );
};

export default LoadingDataComponent;